'use strict';

var glamor = require('glamor');
var axs = require('./axs');
var parse = require('./parse');
var config = require('./config');
var util = require('./util');
var AxsProvider = require('./AxsProvider');

var Box = require('./Box');
var Flex = require('./Flex');
var Text = require('./Text');
var Heading = require('./Heading');
var Color = require('./Color');
var Border = require('./Border');
var Button = require('./Button');

module.exports = {
  glamor: glamor,
  axs: axs,
  parse: parse,
  config: config,
  util: util,
  AxsProvider: AxsProvider,
  Box: Box,
  Flex: Flex,
  Text: Text,
  Heading: Heading,
  Color: Color,
  Border: Border,
  Button: Button
};


//////////////////
// WEBPACK FOOTER
// ./~/axs/dist/index.js
// module id = 104
// module chunks = 0